import React from "react";

const Exercices = () => {
    return (
        <div>
            <h1>Exercices</h1>
            <img src="./Images/travaux.gif" alt="Travaux en cours" />
        </div>
    );
};

export default Exercices;
